export function debounce<F extends (...args: readonly any[]) => void>(
  func: F,
  limit: number,
): (...args: Parameters<F>) => void {
  let debouncing = false;
  let argValues: { args: Parameters<F> } | null = null;

  function timeOutHandler() {
    if (argValues === null)
      debouncing = false;
    else {
      const previousArgValues = argValues;
      argValues = null;
      setTimeout(timeOutHandler, limit);
      func(...previousArgValues.args);
    }
  }

  function debounced(...args: Parameters<F>) {
    if (debouncing) {
      argValues = {args: args};
    }
    else {
      debouncing = true;
      argValues = null;
      setTimeout(timeOutHandler, limit);
      func(...args);
    }
  }

  return debounced as (...args: Parameters<F>) => void;
}
